import Layout from '@/views/Layout.vue'
import { createRouter, createWebHistory } from 'vue-router'
import { useUserStore } from '@/store/user'
import { sendEvent } from '@/helpers/cerebro'
import { isStaging } from '@/helpers/environment'
import { auth } from '@/plugins/firebase'
import { i18n, detectLocale } from '@/plugins/i18n'

const options = {
  redirectPageAfterLogin: { name: 'Payment' },
  redirectPageAfterLogout: { name: 'Survey' },
}

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      component: Layout,
      children: [
        { path: '', redirect: { name: 'Survey' } },
        {
          path: 'onboarding',
          component: () => import('../views/Survey.vue'),
          name: 'Survey',
        },
        {
          path: 'signup',
          component: () => import('../views/EmailSignUp.vue'),
          name: 'SignUp',
          meta: { onlyUnauth: true },
        },
        {
          path: 'payment-result',
          component: () => import('../views/PaymentResult.vue'),
          name: 'PaymentResult',
          meta: { requiresAuth: true },
        },
        ...(isStaging
          ? [
              {
                path: 'settings',
                component: () => import('../views/Settings.vue'),
                name: 'Settings',
                meta: { requiresAuth: true },
              },
            ]
          : []),
      ],
    },
    {
      path: '/payment',
      component: () => import('../views/Payment.vue'),
      name: 'Payment',
      meta: { requiresAuth: true },
    },

    { path: '/:pathMatch(.*)*', redirect: { name: 'Survey' } },
  ],
})

router.beforeEach(async (to, from, next) => {
  // Set locale from ?lang= query param, localStorage, or browser language
  const locale = detectLocale(to.query.lang)
  i18n.global.locale.value = locale

  const userStore = useUserStore()
  const storeUser = await userStore.getCurrentUser()
  const currentUser = auth.currentUser ?? storeUser
  to.query = { ...to.query, ...from.query }
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (currentUser) {
      if (to.matched.some(record => record.meta.onlyPro)) {
        if (userStore.isUserPro()) {
          next()
        } else {
          next(options.redirectPageAfterLogin)
        }
      } else {
        next()
      }
    } else {
      next(options.redirectPageAfterLogout)
    }
  } else if (to.matched.some(record => record.meta.onlyUnauth)) {
    if (currentUser) {
      if (!userStore.isUserPro()) {
        next(options.redirectPageAfterLogin)
      } else {
        next({ name: 'PaymentResult' })
      }
    } else {
      next()
    }
  } else {
    next()
  }
})

router.afterEach((to, from, failure) => {
  if (!failure)
    sendEvent({
      eventName: 'web_page_open',
      page: to.name,
      properties: {
        source: from.name || router.options.history.state.source || '',
        fullPath: to.fullPath,
      },
    })
})

export default router
